export default __webpack_public_path__ + "static/MediaContentSeven-852c3d966419c817f17ed6b79e082299.webp";